"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ParentNotFoundByCodeError extends client_library_1.ExtendableError {
    constructor(code) {
        super(`Parent with code ${code} not found`);
        this.code = code;
    }
}
exports.default = ParentNotFoundByCodeError;
//# sourceMappingURL=ParentNotFoundByCodeError.js.map